/* share social */
$(function() {
    var socialShareTrigger = $('.socialShareToggle');
    var socialShareOptions = $('.socialShareContent');
    var socialShareOption = socialShareOptions.find('a', 'button');
    var socialShareOptionFocus = socialShareOptions.find('a:first-child');
    var socialShareClose = $('.socialShareClose');

    socialShareTrigger.attr('aria-expanded', 'false')
    socialShareOption.attr('tabindex', '-1');

    socialShareTrigger.click(function() {
        event.preventDefault();
        if ($(this).attr('aria-expanded') == ('false')) {
            $(this).attr('aria-expanded', 'true');
            $(this).siblings(socialShareOptions).addClass('__active');
            socialShareOption.attr('tabindex', '0');
            socialShareOptionFocus.focus();
        }

        else {
            $(this).attr('aria-expanded', 'false');
            $(this).siblings(socialShareOptions).removeClass('__active');
            socialShareOption.attr('tabindex', '-1');
        }
    });

    socialShareClose.click(function () {
        $(this).parents(socialShareOptions).siblings(socialShareTrigger).attr('aria-expanded', 'false').focus();
        $(this).parents(socialShareOptions).removeClass('__active');
        $(this).siblings(socialShareOption).attr('tabindex', '-1');
        socialShareTrigger.focus();
    });
});
